import { fetchCompany } from "@rpforms/shared/build/actions";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import styled, { ThemeProvider } from "styled-components";
import { COMPANY_ID } from "../config";
import { RootState } from "../reducers";

const FALLBACK_THEME = { primary_color: "#00bcd4" };

const Center = styled.div`
    display: flex;
    height: 100vh;
    width: 100vw;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export const CompanyContainer = ({ children }) => {
    const company = useSelector<RootState, any>((state) => state.company);
    const dispatch = useDispatch();
    const [loadAttempted, setLoadAttempted] = useState(false);

    useEffect(() => {
        if (company.id) {
            setLoadAttempted(true);
            return;
        }
        const done = () => setLoadAttempted(true);
        Promise.resolve(dispatch(fetchCompany(COMPANY_ID))).then(done, done);
    }, []);

    const theme = () => {
        return company.theme || FALLBACK_THEME;
    };

    return (
        <>
            {(company.id || loadAttempted) && (
                <ThemeProvider theme={theme()}>{children}</ThemeProvider>
            )}
            {!company.id && !loadAttempted && (
                <Center>
                    <Spinner animation={"grow"} variant={"primary"} />
                    wird geladen...
                </Center>
            )}
        </>
    );
};
